import { render, staticRenderFns } from "./PatientPollScoreView.vue?vue&type=template&id=2670ec53&scoped=true"
import script from "./PatientPollScoreView.vue?vue&type=script&lang=js"
export * from "./PatientPollScoreView.vue?vue&type=script&lang=js"
import style0 from "./PatientPollScoreView.vue?vue&type=style&index=0&id=2670ec53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670ec53",
  null
  
)

export default component.exports